import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "feedback/";

// 意见反馈 - 列表
export const feedbackPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };

// 意见反馈 - 添加
export const feedbackAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};

// 意见反馈 - 详情
export const feedbackView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/feedback.js